import { Injectable } from '@angular/core';

export interface NeutralColumn {
	leftProp: string;
	rightProp: string;
	leftName: string;
	rightName: string;
	neutralName: string;
	propWithoutDirection: string;
}

@Injectable({
	providedIn: 'root'
})
export class EditToolService {

	constructor() { }
	transformLeftRightColumnsToNeutral(columns: {prop; name;}[]) {
		const neutralCols: NeutralColumn[] = [];
		columns.forEach(c => {
			if (c.prop.endsWith('_l') || c.prop.endsWith('_r')) {
				const propWithoutDirection = c.prop.substring(0, c.prop.length - 2);
				const lastSpaceIdx = c.name.lastIndexOf(' ');
				const neutralName = c.name.substring(0, lastSpaceIdx);
				let col: NeutralColumn = neutralCols.find(fc => fc.propWithoutDirection === propWithoutDirection);
				if (!col) {
					col = {
						leftProp: null,
						leftName: null,
						rightProp: null,
						rightName: null,
						neutralName: neutralName,
						propWithoutDirection: propWithoutDirection
					};
					neutralCols.push(col);
				}
				if (c.prop.endsWith('_l')) {
					col.leftProp = c.prop;
					col.leftName = c.name;
				} else {
					col.rightProp = c.prop;
					col.rightName = c.name;
				}
			}
		});
		return neutralCols;
	}
}
